import { css } from "@emotion/core";
import styled from "@emotion/styled";

export const CarouselContainer = styled.div<{ marginTop?: number }>`
    width: 100%;
    margin-bottom: 20px;

    ${({ marginTop }) => marginTop && ` margin-top: ${marginTop}px`}
`;

export const Placeholder = styled.div<{ bgColor: string; aspectRatio: number; marginTop?: number }>`
    width: 100%;

    ${({ bgColor, aspectRatio }) => `
        padding-top: ${100 / aspectRatio}%;
        margin-bottom: 40px;
        background: ${bgColor};
    `}

    ${({ marginTop }) => marginTop && `margin-top: ${marginTop}px`}
`;

export const navCss = css`
    background: transparent;
    font-size: 1.5rem;

    &:after {
        content: "\\e910";
        color: #000;
        font-weight: 500;
    }
    &:before {
        content: "\\e910";
        color: #fff;
        position: absolute;
        left: 2px;
    }

    &.next {
        transform: rotate(180deg);
        margin-left: -19px;
        box-shadow: 5px;
    }
`;

export const contentCss = css`
    position: relative;
    width: 100%;
`;

export const dotsCss = css`
    position: relative;
`;
